var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.base64ImgSrc)?_c('img',{staticClass:"profilePicture",attrs:{"src":_vm.base64ImgSrc,"alt":_vm.alternateText}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }